import { GA_MEASUREMENT_ID, DEV_ENV } from './constants/env';

const gtag = window.gtag || function() {};

export function GATrackPageView(title) {
  if (DEV_ENV) return;
  console.log('[GA] track page  view:::: ', title);
  gtag('event', 'page_view', {
    page_title: title,
    page_location: window.location.href,
    page_path: window.location.pathname,
    send_to: GA_MEASUREMENT_ID,
  });
}

export const CustomEvents = {
  SUCCESS_LOGIN: 'success_login',
  GET_CARE_START: 'get_care_start',
  GET_CARE_LEAVE: 'get_care_leave',
  GET_CARE_COMPLETE: 'get_care_complete',
};

export function GATrackCustomEvent(event, options) {
  if (DEV_ENV) return;
  console.log(`[GA] track custom "${event}" action`);
  gtag('event', event, options);
}



// WEBPACK FOOTER //
// ./src/gtag.js